export default "__VITE_ASSET__1894d4ab__"